import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSitemap, faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import SubcuentaDistribucionList from "../SubcuentaDistribucionList/SubcuentaDistribucionList";

const RRDistribuciones = ({ index, style, distribucionesConSubcuentas = [], filter }) => {

    const [distribucionSelected, setDistribucionSelected] = useState('');
    const [openDropdown, setOpenDropdown] = useState(false);

    const handleClick = (key) => {
        (distribucionSelected === key) ? setDistribucionSelected("") : setDistribucionSelected(key);
        setOpenDropdown(prevState => !prevState);
    };

    const getItem = (list) => list[index];

    if (filter === '') {
        const item = getItem(distribucionesConSubcuentas);
        const key = `${item.codDim}-${item.codDis}`;
        return (
            <div style={style} className='warehouseRow' id={key}>
                <div className='warehouseDataRow'>
                    <div className='list-item-icon-w'><FontAwesomeIcon icon={faSitemap} /></div>
                    <div className="label-title-warehouses">Distribución: <h6>{item.codDis}</h6></div>
                    <div className="label-title-warehouses">Descripción: <h6>{item.descrp}</h6></div>
                    <div className="label-title-warehouses">Dimensión: <h6>{item.codDim}</h6></div>
                    <div><h5 style={{ marginTop: "13px" }}>Subcuentas: </h5><h6>
                        <div className="div-icon-warehouse-sectors" onClick={() => handleClick(key)}>
                            {openDropdown === false ? (
                                <FontAwesomeIcon className="icon-warehouse-sectors" icon={faCaretDown} />
                            ) : (
                                <FontAwesomeIcon className="icon-warehouse-sectors" icon={faCaretUp} />
                            )}
                        </div></h6></div>
                </div>
                <div style={{ width: "100%" }}>
                    <SubcuentaDistribucionList
                        subcuentas={item.subcuentas}
                        distribucionKey={key}
                        distribucionSelected={distribucionSelected}
                    />
                </div>
            </div>
        );
    } else {
        const filtered = distribucionesConSubcuentas.filter(d =>
            d.codDis.toLowerCase().includes(filter.toLowerCase()) ||
            d.descrp.toLowerCase().includes(filter.toLowerCase()) ||
            d.codDim.toLowerCase().includes(filter.toLowerCase())
        );
        const item = getItem(filtered);
        const key = `${item.codDim}-${item.codDis}`;
        return (
            <div style={style} className='warehouseRow' id={key}>
                <div className='warehouseDataRow'>
                    <div className='list-item-icon-w'><FontAwesomeIcon icon={faSitemap} /></div>
                    <span><h5>Distribución: </h5><h6>{item.codDis}</h6></span>
                    <span><h5>Descripción: </h5><h6>{item.descrp}</h6></span>
                    <span><h5>Dimensión: </h5><h6>{item.codDim}</h6></span>
                    <span><h5 style={{ marginTop: "13px" }}>Subcuentas: </h5><h6>
                        <div className="div-icon-warehouse-sectors" onClick={() => handleClick(key)}>
                            <FontAwesomeIcon className="icon-warehouse-sectors" icon={faCaretDown} />
                        </div></h6></span>
                </div>
                <div style={{ width: "100%" }}>
                    <SubcuentaDistribucionList
                        subcuentas={item.subcuentas}
                        distribucionKey={key}
                        distribucionSelected={distribucionSelected}
                    />
                </div>
            </div>
        );
    }
};

export default RRDistribuciones;
